export const MRN_TYPE_CODE = "MR" as const;
export const HCN_TYPE_CODE = "SB" as const;

export const V2_0203_SYSTEM = "http://terminology.hl7.org/CodeSystem/v2-0203";
export const HCN_VERSION_CODE_EXTENSION_URL =
  "http://ehealthontario.ca/fhir/StructureDefinition/ext-id-health-card-version-code";

// Base identifier shapes used when creating a new MRN or HCN identifier from scratch.
export const MRN_IDENTIFIER_TEMPLATE = {
  use: "official" as const,
  type: {
    coding: [{ code: MRN_TYPE_CODE, display: "Medical record number", system: V2_0203_SYSTEM }],
    text: "Medical record number",
  },
};

export const HCN_IDENTIFIER_TEMPLATE = {
  use: "official" as const,
  type: {
    coding: [{ code: HCN_TYPE_CODE, display: "Social Beneficiary Identifier", system: V2_0203_SYSTEM }],
    text: "Social Beneficiary Identifier",
  },
};
